module.exports = __webpack_public_path__ + "static/scale-model-of-seattle-chocolate-in-kent-washington-093b01e8a98431e81924ec7866101875.png";